import { createChildFormViewContainer } from 'factories/ChildFormView'
import actions from 'actions/cycleCounts/cycleCountDetails'
import Component from 'components/CycleCounts/Details/FormView'

export default createChildFormViewContainer({ actions })(Component)
